export default [
  {
    path: '/b2bhub/Pedido',
    name: 'pedidos',
    component: () => import('@/views/app/PTC/Pedidos/viewPedidos.vue'),
    meta: {
      pageTitle: 'Pedidos',
      action: 'read',
      resource: 'Acesso_Pedidos',
    },

  },
  {
    path: '/b2bhub/Pedido/PedidoDetalhe/:id',
    name: 'pedido_detalhe',
    component: () => import('@/views/app/PTC/Pedidos/PedidoDetalhe.vue'),
    meta: {
      pageTitle: 'Pedido Detalhe',
      action: 'read',
      resource: 'Acesso_Pedidos',
    },

  },
];
